export default __webpack_public_path__ + "static/media/signup-completed.54f42587.svg";